import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import de from "../locales/de/translation.json";
import en from "../locales/en/translation.json";
import fr from "../locales/fr/translation.json";
import sv from "../locales/sv/translation.json";
import { getBrowserI18nLanguage } from "../utils/browserLanguage";
import { loadCountryNames } from "../utils/countryNames";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sv: { translation: sv },
    de: { translation: de },
    fr: { translation: fr },
  },
  lng: getBrowserI18nLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (language) => void loadCountryNames(language));
void loadCountryNames(i18n.language);

export default i18n;
